export const Loading = () => (
  <div class='component__loading'><span>Loading</span></div>
)
